import {
  Box,
  Button,
  Group,
  Anchor,
  Drawer,
  Burger,
  Stack,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";
import { hotelData } from "../../config/getHotel";
import { useContext } from "react";
import LoginContext from "../../context/LoginContext";


export default function Navbar() {
  const [opened, { toggle, close }] = useDisclosure(false);
  const navigate = useNavigate();
  const context = useContext(LoginContext);
  const hotelName = hotelData.name;
  const themeColor = hotelData.themeColor || "#C9A14A";
  const phone = hotelData.phone;

  console.warn("context in navbar", context)
  const navItems = [
    { label: "Home", path: "/home" },
    { label: "Amenities", path: "/amenities" }, // 👈
    { label: "Wedding Packages", path: "/wedding-packages" },
    { label: "Customer", path: "/customersearch", protected: true }, // 👈
    { label: "Gallery", path: "/gallery" },
    { label: "Contact", path: "/contact" },
  ];

  const filteredNavItems = navItems.filter((item) => {
    if (item.protected && !context?.userId) {
      return false;
    }
    return true;
  });

  const handleNavigate = (path) => {

    if (path === "/logout") {
      sessionStorage.clear();

      navigate("/login");
      context.resetToDefault();
      close();
      return
    }


    navigate(path);
    close();
  };

  return (
    <>
      <Box
        component="header"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          width: "100%",
          zIndex: 300,
          background: "#ffffff",
          borderBottom: "1px solid rgba(0,0,0,0.08)",
        }}
      >
        {/* Desktop */}
        <Box
          visibleFrom="md"
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "220px 1fr 220px",
            alignItems: "center",
            minHeight: "90px",
            padding: "0 48px",
          }}
        >
          <Anchor
            underline="never"
            onClick={() => navigate("home")}
            style={{
              color: themeColor,
              fontSize: "22px",
              fontWeight: 700,
              letterSpacing: "0.12em",
              cursor: "pointer",
            }}
          >
            {hotelName}
          </Anchor>

          <Box
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              width: "100%",
            }}
          >
            {filteredNavItems.map((item) => (
              <Anchor
                key={item.label}
                underline="never"
                onClick={() => handleNavigate(item.path)}
                style={{
                  color: themeColor,
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                {item.label}
              </Anchor>
            ))}


            {context?.userId ? (
              <Anchor
                underline="never"
                onClick={() => handleNavigate("/logout")}
                style={{
                  color: themeColor,
                  fontSize: "16px",
                  fontWeight: 500,
                  letterSpacing: "0.06em",
                  cursor: "pointer",
                }}
              >
                Log Out
              </Anchor>
            ) : (
              <Anchor
                underline="never"
                onClick={() => navigate("/login")}
                style={{
                  color: themeColor,
                  fontSize: "16px",
                  fontWeight: 500,
                  letterSpacing: "0.06em",
                  cursor: "pointer",
                }}
              >
                Login
              </Anchor>
            )}

          </Box>

          <Group justify="flex-end">
            <Button
              radius="xl"
              component="a"
              href={`tel:${phone}`}
              style={{
                background: themeColor,
                color: "#fff",
                paddingInline: 28,
              }}
            >
              Call Now
            </Button>
          </Group>
        </Box>

        {/* Mobile */}
        <Box
          hiddenFrom="md"
          style={{
            minHeight: "72px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 18px",
          }}
        >
          <Anchor
            underline="never"
            onClick={() => navigate("/home")}
            style={{
              color: themeColor,
              fontSize: "18px",
              fontWeight: 700,
              letterSpacing: "0.08em",
              cursor: "pointer",
            }}
          >
            {hotelName}
          </Anchor>

          <Burger
            opened={opened}
            onClick={toggle}
            aria-label="Toggle navigation"
            color={themeColor}
            size="lg"
          />
        </Box>
      </Box>

      {/* Mobile Drawer */}
      <Drawer
        opened={opened}
        onClose={close}
        position="right"
        size="78%"
        padding="lg"
        withCloseButton={false}
        styles={{
          body: {
            paddingTop: "80px"
          }
        }}
      >
          <Stack gap="lg">
            {filteredNavItems.map((item) => (
              <Anchor
                key={item.label}
                underline="never"
                onClick={() => handleNavigate(item.path)}
                style={{
                  color: themeColor,
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                {item.label}
              </Anchor>
            ))}

            {/* 👇 Login / Logout for mobile */}
            {context?.userId ? (
              <Anchor
                underline="never"
                onClick={() => handleNavigate("/logout")}
                style={{
                  color: themeColor,
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                Log Out
              </Anchor>
            ) : (
              <Anchor
                underline="never"
                onClick={() => {
                  navigate("/login");
                  close();
                }}
                style={{
                  color: themeColor,
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                Login
              </Anchor>
            )}

            <Button
              radius="xl"
              component="a"
              href={`tel:${phone}`}
              style={{
                background: themeColor,
                color: "#fff",
              }}
            >
              Call Now
            </Button>
          </Stack>
       
      </Drawer>

      <Box h={{ base: 72, md: 90 }} />
    </>
  );
}